<template>
    <modal :show.sync=show size="xl" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Select Unit</h3>
        <div>
            <div v-if="unitCategory(selected_project.project_type) !== 'landed'">
                <b-row>
                    <div class="table-select-unit">
                        <b-table-simple responsive bordered>
                            <b-tbody>
                                <b-tr v-for="(level, levelIndex) in filteredUnitByLevel" :key="levelIndex">
                                    <b-td v-if="level.length > 0">
                                        <h4>Level {{ level[0].floor_sort }}</h4>
                                        <span class="text-primary text-xs cursor-pointer" @click="openLevelPlan(level[0])">View level plan</span>
                                    </b-td>
                                    <b-td v-for="(unit, unitIndex) in level" :key="unitIndex"
                                        :class="{'bg-secondary': !unit}"
                                        :style="getCellStyle(unit)"
                                    >
                                        <div v-if="unit">
                                            <a href="javascript:void(0)" @click="selectUnit(unit)">
                                                <div :style="{
                                                        'cursor': unit.available_status === 'Open' ? 'pointer' : 'not-allowed'
                                                    }"
                                                    class="text-center"
                                                >
                                                    <p class="text-xs text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                                    <p class="text-xs font-weight-600">RM {{ unit.unit_price | moneyFormatter }}</p>
                                                    <span class="text-dark text-xs">{{ unit.unit_no }} | {{ unit.unit_type.unit_type_name }}</span>
                                                    <div class="m-0 p-0 text-right">
                                                        <p class="h2 p-0 mb-0"
                                                            v-if="isEligible(unit.unit_price)"
                                                        >
                                                            <b-icon icon="check-circle-fill" variant="success" v-b-tooltip.hover="'Eligible'"></b-icon>
                                                        </p>
                                                        <p class="h2 p-0 mb-0" v-else>
                                                            <b-icon icon="x-circle-fill" variant="danger" v-b-tooltip.hover="'Not Eligible'"></b-icon>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </b-td>
                                    <b-td v-for="index in maxColumns - level.length" :key="'empty-' + index"></b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <div class="table-select-unit">
                        <b-table-simple responsive bordered>
                            <tbody>
                                <b-tr v-for="(row, rowIndex) in groupedUnits" :key="rowIndex">
                                    <b-td v-for="(unit, unitIndex) in row" :key="unitIndex"
                                        :class="{'bg-secondary': !unit}"
                                        :style="getCellStyle(unit)"
                                    >
                                        <div v-if="unit">
                                            <a href="javascript:void(0)" @click="selectUnit(unit)">
                                                <div :style="{
                                                        'cursor': unit.available_status === 'Open' ? 'pointer' : 'not-allowed'
                                                    }"
                                                    class="text-center"
                                                >
                                                    <p class="text-xs text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                                    <p class="text-xs font-weight-600">RM {{ unit.unit_price | moneyFormatter }}</p>
                                                    <span class="text-dark text-xs">{{ unit.unit_no }} | {{ unit.unit_type.unit_type_name }}</span>
                                                    <div class="m-0 p-0 text-right">
                                                        <p class="p-0 mb-0"
                                                            v-if="isEligible(unit.unit_price)"
                                                        >
                                                            <b-icon icon="check-circle-fill" variant="success" v-b-tooltip.hover="'Eligible'"></b-icon>
                                                        </p>
                                                        <p class="p-0 mb-0" v-else>
                                                            <b-icon icon="x-circle-fill" variant="danger" v-b-tooltip.hover="'Not Eligible'"></b-icon>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </b-td>
                                </b-tr>
                            </tbody>
                        </b-table-simple>
                    </div>
                </b-row>
            </div>
        </div>
    </modal>
</template>
<script>
import { Button } from 'element-ui'
import { useCustomerStore } from '@/stores/customerStore'
import { mapState } from 'pinia'

export default {
    props: [
        'expand_units', 
        'selected_project',
        'unit_by_level', 
        'unitCategory', 
        'filteredUnitByLevel',
        'groupedUnits',
        'openLevelPlan',
        'getCellStyle',
        'maxColumns',
        'selectUnit'
    ],
    components: {
        [Button.name]: Button,
    },
    computed: {
        show: {
            get() {
                return this.expand_units;
            },
            set(value) {
                this.$emit('update:expand_units', value);
            }
        },
        ...mapState(useCustomerStore, ['current_eligibility']),
    },
    methods: {
        isEligible(unitPrice) {
            const maxEligibility = this.current_eligibility && this.current_eligibility.max_eligibility 
                ? parseFloat(this.current_eligibility.max_eligibility) 
                : 0;

            return maxEligibility >= parseFloat(unitPrice);
        }
    }
}
</script>